import * as React from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined'
import { MoreButton } from '@sales-center/components'
import { useHandlers, useMoreOptions } from './hooks'
import type { ActivityDetails } from '@user/features/Activity/typings'
import type { ENTITY_TYPES } from '@sales-center/common'
import { useActivityData } from '@user/features/Activity/hooks'

type Props = {
  title?: string
  activity?: ActivityDetails
  entityId: number
  entityType: ENTITY_TYPES
}

export function ActivityDetailsHeader(props: Props) {
  const { title, activity, entityId, entityType } = props
  const { handleBackClick } = useHandlers()
  const options = useMoreOptions({ entityId, entityType })

  const { updateDeleteEnabled } = useActivityData({ activity })

  return (
    <Stack>
      <Stack direction="row" spacing={1} mb={2} alignItems="center">
        <IconButton
          size="small"
          onClick={handleBackClick}
          data-test-id={`activity-back-button-${activity?.id}`}
        >
          <ChevronLeft />
        </IconButton>
        <Typography variant="body2">Activities</Typography>
      </Stack>
      <Stack direction="row" spacing={1} mb={1.4} alignItems="start">
        <Box pt="0px">
          <AssignmentOutlined color="primary" fontSize="small" />
        </Box>
        <Typography variant="h6" mr="auto!important" lineHeight="1">
          Subject: {title}
        </Typography>
        {updateDeleteEnabled && (
          <MoreButton
            options={options}
            dataTestId={`activity-more-button-${activity?.id}`}
          />
        )}
      </Stack>
    </Stack>
  )
}
